import React from "react";
import {
  FormControlLabel,
  Typography,
  Button,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
function ViewResult() {
  return (
    <>
      <Typography component="subtitle2" align="center">
        (주)신원 특판 멤버십 서비스 및 일체의 마케팅 활동을 위해 개인정보를
        제공, 활용하는데 동의합니다.
      </Typography>
      <hr />
    </>
  );
}
function Marketing(props) {
  const classes = props.useStyles();
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.marketing}
              onChange={(e) => {
                props.onChangeMarketing(e.target.checked);
              }}
              name="Marketing"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [선택]마케팅 활용 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}
export default Marketing;
